import { render, staticRenderFns } from "./_delete-dialog.vue?vue&type=template&id=867bbc64&scoped=true"
import script from "./_delete-dialog.vue?vue&type=script&lang=js"
export * from "./_delete-dialog.vue?vue&type=script&lang=js"
import style0 from "./_delete-dialog.vue?vue&type=style&index=0&id=867bbc64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867bbc64",
  null
  
)

export default component.exports